import React, { createContext, useContext, useRef, useState } from 'react';
import { Collection } from 'ol';
var OpenLayersContext = /*#__PURE__*/createContext({});
export var useOpenLayers = () => {
  var context = useContext(OpenLayersContext);

  if (context === undefined) {
    throw new Error('useOpenLayers must be used within a MapProvider[OpenLayersProvider].');
  }

  return context;
};
export var OpenLayersProvider = _ref => {
  var {
    children
  } = _ref;
  var [map, setMap] = useState();
  var currentDrawInteractionRef = useRef();
  var layerRef = useRef();
  var featureCollection = useRef(new Collection([], {
    unique: true
  }));
  var mapContainerRef = useRef();
  var layerSwitcherTargetRef = useRef();
  var resetPositionTargetRef = useRef();
  var addLayerTargetRef = useRef();
  var drawTargetRef = useRef();
  var modifyTargetRef = useRef();
  var resetTargetRef = useRef();
  var undoTargetRef = useRef();
  var measurementsTargetRef = useRef();
  var validateFeaturesRef = useRef();
  var loadGeoJSONRef = useRef();
  var getShapesTargetRef = useRef();
  var toolbarTargetRef = useRef();
  var centerMarkerEventKey = useRef(null);
  var clusterRef = useRef();
  var undoRedoFeaturesRef = useRef();
  var storybookControlRef = useRef();
  var overlayElementRef = useRef();
  var geometryAreas = useRef([]);
  var mapRef = useRef();
  mapRef.current = map;
  return /*#__PURE__*/React.createElement(OpenLayersContext.Provider, {
    value: {
      map,
      mapRef,
      mapContainerRef,
      layerSwitcherTargetRef,
      featureCollection,
      resetPositionTargetRef,
      addLayerTargetRef,
      drawTargetRef,
      modifyTargetRef,
      resetTargetRef,
      undoTargetRef,
      clusterRef,
      undoRedoFeaturesRef,
      storybookControlRef,
      measurementsTargetRef,
      validateFeaturesRef,
      loadGeoJSONRef,
      getShapesTargetRef,
      toolbarTargetRef,
      centerMarkerEventKey,
      currentDrawInteractionRef,
      geometryAreas,
      layerRef,
      setMap,
      overlayElementRef
    }
  }, children);
};